import React, { Component } from 'react';
import { Spinner, SpinnerSize } from '@fluentui/react';

class Loading extends Component {
    render() {

        return (
            <div class="loading-overlay" {...this.props}>
                <Spinner label="Loading" size={SpinnerSize.large}/>
            </div>
        );
    }
}

export default Loading;